import { createContext } from 'react';

const SchoolCourseContext = createContext(null);

export default SchoolCourseContext;



// WEBPACK FOOTER //
// ./components/groups/context/school-course-context.js